/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Avatar,
  Box,
  Card,
  Container,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import Genders from "models/Enums/Genders";
import classes from "./style";
import { getImageUrl, readFileDataAsBase64 } from "utils/imageUtils";
import User from "models/User";
import { SET_USER } from "slices/global.slice";
import profilService from "services/profilService";
import ImagesCarousel from "components/carousel/Carousel";

const Passeport: FC<{}> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.globalSlice);
  const [imgUrl, setImgUrl] = useState(user?.profilePicture);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('lg'));
  const [selectedImage, setSelectedImage] = useState<any>(null);

  const updateUser = (user: User) => {
    dispatch(SET_USER(user));
  }

  const hiddenFileInput = React.useRef(null);

  const calculateAge = (birthday: Date): number => {
    return Math.floor(
      (new Date().getTime() - new Date(birthday).getTime()) /
      (365.25 * 24 * 60 * 60 * 1000),
    );
  };

  const handleChange = async (e: any) => {
    const base64 = await readFileDataAsBase64(e.target.files[0]) as string;
    const r = await profilService.updateProfilPicture(base64);
    setImgUrl(r);
    updateUser({ ...user, profilePicture: r });
  };


  const handleClick = () => {
    if (hiddenFileInput) {
      (hiddenFileInput.current as any).click();
    }
  };

  return (
    user && (<>
      <Container sx={classes.emptyPasseport}>
        <Typography variant="h1" my={5}>
          PASSEPORT
        </Typography>

        <Grid container sx={classes.messagerie} my={3} pb={!isMd ? 3 : 0}>
          <Grid item xs={12} md={6} lg={3} sx={classes.profileBloc}>
            <Box sx={{ position: "relative" }} onClick={handleClick}>
              <Avatar
                sx={classes.profileAvatar}
                alt={`${user.firstName} ${user.lastName}`}
                src={getImageUrl(imgUrl)}
              />
              <Box sx={classes.uploadAvatar}>
                <AddAPhotoIcon />
              </Box>
            </Box>

            <input
              type="file"
              style={{ display: "none" }}
              ref={hiddenFileInput}
              onChange={handleChange}
            />

            <List dense>
              <ListItem onClick={() => navigate("/passeport-edition")}>
                <ListItemText
                  primary="Paramètres"
                />
                <ListItemAvatar>
                  <Avatar>
                    <ModeEditOutlineOutlinedIcon />
                  </Avatar>
                </ListItemAvatar>
              </ListItem>
              {/* <ListItem
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="edit"
                  color="primary"
                  onClick={() => navigate("/passeport-edition")}
                >
                  <ModeEditOutlineOutlinedIcon />
                </IconButton>
              }
            >
              <ListItemAvatar>
                <Avatar>
                  <SettingsIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Paramètres" />
            </ListItem> */}
            </List>
          </Grid>
          <Grid item xs={12} md={6} lg={5}>
            <Card>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Box>
                  <Typography component="div" variant="h5">
                    {`${user.firstName}, ${user.lastName}`}
                  </Typography>
                  <Typography component="div" variant="body2">
                    {`${
                      // eslint-disable-next-line no-nested-ternary
                      Genders[user.gender] === "Male"
                        ? "Homme"
                        : Genders[user.gender] === "Female"
                          ? "Femme"
                          : "Autre"
                      }, ${calculateAge(new Date(user.birthDay))} ans`}
                  </Typography>
                </Box>
                <IconButton aria-label="edit">
                  <ModeEditOutlineOutlinedIcon
                    sx={classes.editIcon}
                    onClick={() => navigate("/passeport-edition")}
                  />
                </IconButton>
              </Box>
              <Box>
                <List dense>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <MapOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Destinations"
                      secondary={user.pastTravels?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <AirplanemodeActiveOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Moyens de transport"
                      secondary={user.favoriteTransports?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <SportsBasketballOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Ambiance"
                      secondary={user.favoriteStayTypes?.join(" , ")}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <MapOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Description"
                      secondary={user.description}
                    />
                  </ListItem>
                </List>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} lg={4} sx={!isMd ? null : classes.imageListBloc}>
            <IconButton aria-label="edit">
              <ModeEditOutlineOutlinedIcon
                sx={classes.editIcon}
                onClick={() => navigate("/passeport-edition")}
              />
            </IconButton>
            <ImageList variant="quilted" cols={2} sx={{ minHeight: '100px' }}>
              {[0, 1, 2].map((item, i) => (
                <ImageListItem key={item.toString()} cols={i == 0 ? 2 : 1} rows={1}>
                  {
                    user.personalPictures?.length > i ?
                      <img src={getImageUrl(user.personalPictures[i])} width="100%" height="100%"
                        loading="lazy" onClick={() => setSelectedImage({ img: getImageUrl(user.personalPictures[i]), title: user.personalPictures[i] })} />
                      :
                      <Skeleton variant="rectangular" width="100%" height="100%" />
                  }
                </ImageListItem>
              ))}
            </ImageList>
          </Grid>
        </Grid>
      </Container>
      {
        user.personalPictures?.length > 0 ?
          <ImagesCarousel
            open={selectedImage ? true : false}
            images={user.personalPictures.map((i) => {
              return {
                img: getImageUrl(i),
                title: i,
              };
            })}
            selectedImage={selectedImage}
            handleClose={() => {
              setSelectedImage(null);
            }}
          /> : ''
      }
    </>
    )
  );
};

export default Passeport;

